import React, { Component, createRef, RefObject } from 'react'
import Textarea from 'react-textarea-autosize'

import { EditConfirmationButton } from '../EditConfirmationButton'
import { IMessage, MessageType } from '../index'

import './index.scss'

type Props = {
  onFinishEdit: (message) => void
  initialMessage: Partial<IMessage>
}

type State = {
  isTooLong: boolean
  messageText: string
}

export class MessageEditor extends Component<Props, State> {
  public state = {
    isTooLong: false,
    messageText: ''
  }

  private textareaRef: RefObject<HTMLTextAreaElement>

  constructor(props) {
    super(props)
    this.textareaRef = createRef()
  }

  componentDidMount() {
    const { initialMessage } = this.props
    if (initialMessage && initialMessage.content) {
      this.setState({ messageText: initialMessage.content })
    }
    if (this.textareaRef.current) {
      this.textareaRef.current.focus()
      // Wait until textarea has loaded its content
      setTimeout(() => {
        if (this.textareaRef.current) {
          this.textareaRef.current.scrollTo(0, this.textareaRef.current.scrollHeight)
        }
      }, 10)
    }
  }

  updateMessageText = (event) => {
    const value = event.currentTarget.value
    this.setState({ messageText: value })
  }

  private handleHeightChange = (height) => {
    this.setState({ isTooLong: height > 180 })
  }

  private handleClick = () => {
    this.props.onFinishEdit(this.state.messageText)
  }

  public render() {
    const { initialMessage } = this.props
    const { isTooLong, messageText } = this.state

    return (
      <>
        <div
          className={`
                modern-chat-message-editor__wrapper
                ${
                  initialMessage.type === MessageType.Answer
                    ? 'modern-chat-message-editor__wrapper--answer'
                    : ''
                }
              `}
        >
          <div
            className={`
                  modern-chat-message-editor__inner
                  ${isTooLong ? 'modern-chat-message-editor__inner--tooLong' : ''}
                `}
            data-testid='modern-chat-message-editor__inner'
          >
            <Textarea
              className={`
                      modern-chat-message-editor__textarea
                      ${isTooLong ? 'modern-chat-message-editor__textarea--tooLong' : ''}
                    `}
              onChange={this.updateMessageText}
              inputRef={this.textareaRef}
              value={messageText}
              onHeightChange={this.handleHeightChange}
              placeholder={'Beschreibe hier kurz Dein Problem und stelle Deine Fragen.'}
              style={{ fontSize: '16px' }}
            />
          </div>
        </div>
        <EditConfirmationButton
          disabled={!messageText || messageText === ''}
          onClick={this.handleClick}
        />
      </>
    )
  }
}
